import type {
  FieldOpsQueueOwner,
  FieldOpsQueueOwnerInput,
  FieldOpsQueueOwnerPatch,
  FieldOpsTeam,
  ResolvedQueueOwner,
} from '../domain/fieldOpsTeam';
import { fieldOpsQueueOwnersApi as liveApi } from './live-field-ops-queue-owners-api';
import { fieldOpsQueueOwnersApi as mockApi } from './mock-field-ops-queue-owners-api';

/**
 * Field Ops queue-owner configuration, backed by leatherback's
 * FieldOpsQueueOwnersService -- see domain/fieldOpsTeam.ts. Mirrors the
 * Opportunity project's contract-signer settings.
 */
export interface FieldOpsQueueOwnersApi {
  listQueueOwners(includeInactive?: boolean): Promise<FieldOpsQueueOwner[]>;
  createQueueOwner(input: FieldOpsQueueOwnerInput): Promise<FieldOpsQueueOwner>;
  updateQueueOwner(patch: FieldOpsQueueOwnerPatch): Promise<FieldOpsQueueOwner>;
  // Who work for `team` routes to right now, with how it was decided.
  // Rejects with NotFoundError when no eligible owner covers the team.
  resolveQueueOwner(team: FieldOpsTeam): Promise<ResolvedQueueOwner>;
}

export const fieldOpsQueueOwnersApi: FieldOpsQueueOwnersApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveApi : mockApi;
